$(document).ready(function() {
  var sidebar = $('.p__dashboard--sidebar');
  if ($(sidebar).length) {
    $('#hamburger').on('click', function() {
      $(this).toggleClass('open');
      $(sidebar).toggleClass('open');
    });
  }


  $('button[action="openChildForm"]').on('click', function() {
    var $this = $(this);
    $this.fadeOut(300);
    setTimeout(function() {
      $this.next('.form--data').fadeIn(300);
    }, 400);

  });
});

$('.checkMobile').on('click', function() {
  $(this).toggleClass('active');
})



// WEBPACK FOOTER //
// ./assets/js/dashboard.js